// IMMEDIATE DEBUG LOG TO CHECK IF TRADE2 FILE IS LOADED
console.log('🔥🔥🔥 TRADE2.TSX FILE LOADED!!!');

import React, { useState, useEffect } from 'react';
import { TrendingUp } from 'lucide-react';
import SimpleChart from '../components/AdvancedCharts/SimpleChart';
import CanvasSidebar from '../components/canvas/CanvasSidebar';
import TokenTransactions from '../components/TokenTransactions';
import { Token } from '../types/supabase';
import { CanvasWidget } from '../components/canvas/types';

interface Trade2Props {
  walletAddress?: string;
  walletProvider?: 'phantom' | 'solflare' | null;
}

const Trade2: React.FC<Trade2Props> = ({ walletAddress, walletProvider }) => {
  // IMMEDIATE DEBUG LOG TO CHECK IF TRADE2 COMPONENT IS RENDERED
  console.log('🔥🔥🔥 TRADE2 COMPONENT RENDERED!!!');
  console.log('🔥🔥🔥 Trade2 props:', { walletAddress, walletProvider });
  
  const [selectedToken, setSelectedToken] = useState<Token | undefined>(undefined);
  
  // Log wallet info when component mounts
  useEffect(() => {
    if (walletAddress) {
      console.log(`Trade2 view initialized with wallet: ${walletAddress} (${walletProvider})`);
    } else {
      console.log('Trade2 view initialized without a connected wallet');
    }
  }, [walletAddress, walletProvider]);
  
  // Placeholder function for adding widgets (required by CanvasSidebar)
  const handleAddWidget = (widget: Partial<CanvasWidget>) => {
    console.log("Widget would be added:", widget);
    // If widget has a token, set it as the selected token
    if ('selectedToken' in widget && widget.selectedToken) {
      setSelectedToken(widget.selectedToken as Token);
    }
  };

  return (
    // Using fixed positioning to ensure the component stays between navbar and bottom bar
    // The navbar is fixed at top-0 with variable height (let's use 56px as standard)
    // No bottom bar in Trade2, so we go all the way to the bottom
    <div className="fixed top-14 bottom-0 left-0 right-0 flex z-10">
      {/* Left column with CanvasSidebar */}
      <div className="w-72 h-full">
        <CanvasSidebar onAddWidget={handleAddWidget} />
      </div>
      {/* Middle column with chart */}
      <div className="flex-1 h-full bg-dark-grey/30 border-l border-gray-800/30">
        <div className="h-full w-full overflow-hidden">
          <SimpleChart selectedToken={selectedToken} />
        </div>
      </div>
      {/* Right column with transactions */}
      <div className="w-96 h-full border-l border-gray-800/30 overflow-hidden">
        <TokenTransactions selectedToken={selectedToken} maxTransactions={20} />
      </div>
    </div>
  );
};

export default Trade2; 